<template>
  <div class="team-quota">
    <h5>
      <span class="value">{{ client.used.users }} of {{ client.quota.users }} seats used</span>
      {{ label }}
    </h5>
    <el-progress :percentage="percentage" :status="status" :show-text="false" />
  </div>
</template>

<script>
export default {
  props: {
    client: {
      type: Object,
      default: () => ({})
    },
    label: {
      type: String,
      default: 'Runstack Team'
    }
  },
  computed: {
    percentage () {
      if (this.client.quota.users === 0) {
        return 0
      }
      return ((this.client.used.users) / this.client.quota.users) * 100
    },
    status () {
      return this.percentage > 70 ? 'warning' : 'success'
    }
  }
}
</script>

<style lang="scss" scoped>
  .team-quota {
    margin-top: 24px;

    h5 {
      margin-top: 0;
      margin-bottom: 12px;

      span {
        float: right;
      }
    }
  }
</style>
